import React, { useState } from "react";
import { INFRA_PAGE } from "../../data/constants";
import facility1 from "../../assets/fac.png";
import facility2 from "../../assets/fac1.png";
import facility3 from "../../assets/fac2.png";
import facility4 from "../../assets/fac3.png";
import chevronLeft from "../../assets/arrow-right.png";
import chevronRight from "../../assets/arrow-left.png";

const facilityImages = [facility1, facility2, facility3, facility4];
const facilities = INFRA_PAGE.facility.facilities.map((f, i) => ({
  ...f,
  image: facilityImages[i],
}));

const FacilitySectionDesktop = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const certLogos = INFRA_PAGE.facility.certificationLogos;

  return (
    <div className="bg-white">
      {/* Certifications */}
      <div className="py-12 px-6 md:px-20">
        <p className="font-inter font-semibold text-[20px] leading-[150%] tracking-[-0.005em] bg-gradient-to-t from-[#46C1BF] to-[#46C1BF] bg-clip-text text-transparent mb-4">{INFRA_PAGE.facility.certificationsLabel}</p>
        <div className="overflow-x-hidden">
          <div className="w-full">
             {/* w-max animate-facility-marquee */}
            <div className="flex !justify-between">
              {[...certLogos].map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt="Certification"
                  className="w-auto"
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="relative w-screen h-[845px] overflow-hidden">
        {/* Left Chevron */}
        <button
          className="absolute left-[85px] top-1/2 z-30 transform -translate-y-1/2 "
          onClick={() => setActiveIndex((prev) => Math.max(prev - 1, 0))}
          disabled={activeIndex === 0}
          aria-label="Previous facility"
        >
          <img src={chevronLeft} alt="Previous"  />
        </button>
        {/* Right Chevron */}
        <button
          className="absolute right-[85px] top-1/2 z-30 transform -translate-y-1/2 "
          onClick={() => setActiveIndex((prev) => Math.min(prev + 1, facilities.length - 1))}
          disabled={activeIndex === facilities.length - 1}
          aria-label="Next facility"
        >
          <img src={chevronRight} alt="Next"  />
        </button>
        {/* Slider Track */}
        <div
          className="flex transition-transform duration-700 ease-in-out h-full"
          style={{
            width: `${facilities.length * 100}vw`,
            transform: `translateX(-${activeIndex * 100}vw)`,
          }}
        >
          {facilities.map((facility, i) => (
            <div
              key={i}
              className="w-screen h-full bg-cover bg-center flex-shrink-0"
              style={{ backgroundImage: `url(${facility.image})` }}
            />
          ))}
        </div>

        {/* Overlay Gradient */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#011621] to-transparent z-10" />

        {/* Text Content */}
        <div className="absolute inset-0 z-20 flex flex-col justify-center items-center text-white text-center py-0">
          <h2 className="font-utility font-medium text-[54px] leading-[120%] tracking-[-0.01em] mt-0 mb-[484px]">
            Our facility
          </h2>
          <p className="font-utility text-[24px] font-medium leading-[130%] mb-10">
            {facilities[activeIndex].label}
          </p>

          {/* Stepper */}
          <div className="flex gap-8 mt-0">
            {facilities.map((_, i) => (
              <button
                key={i}
                onClick={() => setActiveIndex(i)}
                className={`h-2 w-[111px] rounded-none transition duration-200 ${
                  activeIndex === i ? "bg-white" : "bg-white/50"
                }`}
                aria-label={`Go to facility ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacilitySectionDesktop; 